<template>
  <field
    :id="uid"
    v-model="model"
    class="peer absolute h-0 w-0 appearance-none opacity-0"
    :disabled="disabled"
    :name="name"
    :type="type"
    :value="value"
    :unchecked-value="uncheckedValue"
  />
  <label :for="uid" v-bind="$attrs">
    <slot />
  </label>
</template>

<script lang="ts" setup generic="V extends number | string | boolean, T extends 'checkbox' | 'radio'">
import { Field } from 'vee-validate';
defineProps<{
  name: string;
  type: T;

  value: V;
  uncheckedValue: boolean;

  disabled?: boolean;
}>();

defineOptions({ inheritAttrs: false });

const model = defineModel<T extends 'checkbox' ? (V extends boolean ? boolean : Array<V>) : null | V>({
  required: true,
});

const uid = useId();
</script>
